import script from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"

import "./SellerPriceOffer.vue?vue&type=style&index=0&id=e748da54&lang=scss&scoped=true"
import "./SellerPriceOffer.vue?vue&type=style&index=1&id=e748da54&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e748da54"]])

export default __exports__